import axios from 'axios';

export const apiClient = axios.create({
    baseURL: (() => {
        const url = process.env.REACT_APP_API_BASE_URL || 'https://tppw2r9wge.us-east-1.awsapprunner.com/api';
        // const url = 'https://tppw2r9wge.us-east-1.awsapprunner.com/api';
        return url;
    })(),
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: false
});

// Add axios interceptor to include token in requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let modalController: { openLoginModal: () => void } | null = null;
let authController: { clearAuth: () => void } | null = null;

export const setModalController = (controller: { openLoginModal: () => void }) => {
    modalController = controller;
};

export const setAuthController = (controller: { clearAuth: () => void }) => {
    authController = controller;
};

// Add response interceptor to handle unauthorized errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
        authController?.clearAuth();
        modalController?.openLoginModal();
    }
    return Promise.reject(error);
  }
);